export default {
  'promoHeader': 'Ben je het vergeten?',
  'add':'Voeg toe',
  'pickSize':'Kies maat',
  'cartHeader':'Je winkelwagen:',
  'addUniid':'Voeg naam en nummer toe',
  'remove':'Verwijder',
  'freeDelivery':'Hey, je hebt gratis verzending!',
  'toCheckout':'Ga door naar checkout',
  'totalPrice':'Totaal:',
  'totalDiscount':'Korting totaal:',
  'deliveryPrice':'Verzendkosten:',
  'size':'Maat:',
  'getTomoz':'',
  'totalVAT':'BTW totaal:',
  'consent': 'Yes - I allow Unisport to send me email and sms\'s on similar football products. I can unsubscribe at any time in the email or by un-ticking this box, should the communication not be as expected.'
}